import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

//import images
import avatar1 from "../../assets/images/users/userPlaceHolder.png";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { ErrorHandler, SuccessToast } from "utils/toast";
import { deleteUser, logoutUser } from "slices/thunks";
import Icon from "Components/Icons/Icon";
import DeleteItemModal from "Components/Modals/DeleteItemModal";
import { restartAllTours } from "slices/tour/reducer";
import FullScreenLoader from "./FullScreenLoader";

const ProfileDropdown = () => {
  // Inside your component
  const user = useAppSelector((state) => state?.auth?.user);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const role = user?.role;

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showLogoutModal, setShowLogoutModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleLogout = async () => {
    try {
      setShowLogoutModal(false);
      setIsLoading(true);
      await dispatch(logoutUser())?.unwrap();
      dispatch(restartAllTours());
      navigate("/login", { replace: true });
      SuccessToast("You have been logged out successfully.");
    } catch (error) {
      console.log("logout err", error);
      ErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    try {
      setShowDeleteModal(false);
      setIsLoading(true);
      await dispatch(deleteUser())?.unwrap();
      dispatch(restartAllTours());
      setShowDeleteModal(false);
      navigate("/login", { replace: true });
      SuccessToast("Account Deleted Successfully");
    } catch (error) {
      console.log("logout err", error);
      ErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <FullScreenLoader isLoading={isLoading} message="Processing..." />
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <div className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={user?.avatar || avatar1}
              alt="Header Avatar"
              onError={(e) => {
                e.currentTarget.src = avatar1;
              }}
            />

            <span
              className="ms-xl-2 fw-medium user-name-text d-none d-xl-inline-block"
              style={{
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {user?.name || "Admin"}
            </span>
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6
            className="dropdown-header"
            style={{
              maxWidth: 170,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Welcome {user?.name}!
          </h6>
          {role === "user" && (
            <DropdownItem className="p-0">
              <div
                className="dropdown-item"
                onClick={() => {
                  setShowDeleteModal(true);
                }}
              >
                <Icon name="Delete" className="me-2" />
                <span className="align-middle fs-14 fw-normal font-primary text-black2D">
                  Delete Account
                </span>
              </div>
            </DropdownItem>
          )}
          <DropdownItem className="p-0">
            <div
              className="dropdown-item"
              onClick={() => {
                setShowLogoutModal(true);
              }}
            >
              <Icon name="Logout" className="me-2" />
              <span className="align-middle fs-14 fw-normal font-primary text-black2D">
                Logout
              </span>
            </div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <DeleteItemModal
        description="Are you sure you want to logout?"
        onCloseClick={() => {
          setShowLogoutModal(false);
        }}
        onDeleteClick={handleLogout}
        show={showLogoutModal}
        title={"Logout"}
        icon={<i className="ri-logout-circle-line display-5 text-primary"></i>}
        confirmText={"Logout"}
        disabled={isLoading}
      />
      <DeleteItemModal
        description="Are you sure you want to delete your account?"
        onCloseClick={() => {
          setShowDeleteModal(false);
        }}
        onDeleteClick={handleDeleteAccount}
        show={showDeleteModal}
        title={"Delete Account"}
        icon={<i className="ri-delete-bin-5-line display-5 text-danger"></i>}
        confirmText={"Yes, Delete It!"}
        disabled={isLoading}
      />
    </React.Fragment>
  );
};

export default ProfileDropdown;
